import { nextTick, ref, watch } from 'vue'

export function useAuthAccessibility(currentStep, stepError, stepAnnouncements = {}) {
  const announcement = ref('')

  const announce = (message) => {
    if (!message) return

    announcement.value = ''
    nextTick(() => {
      announcement.value = message
    })
  }

  const focusStep = async () => {
    await nextTick()

    requestAnimationFrame(() => {
      const main = document.getElementById('auth-login-main')
      if (!main) return

      const target = main.querySelector('[data-step-focus]')
        || main.querySelector('input:not([disabled])')
        || main.querySelector('button:not([disabled])')
        || main.querySelector('select:not([disabled])')

      target?.focus?.()
    })
  }

  watch(currentStep, (step) => {
    focusStep()
    announce(stepAnnouncements[step] ?? '')
  })

  watch(stepError, (message) => {
    if (message) {
      announce(message)
    }
  })

  return {
    announcement,
    announce,
    focusStep,
  }
}
